import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import { transformCrmGuestOrderResponse, transformCrmGuestReturnsResponse, transformCrmGuestReturnResponse, transformSalesCheckoutGiftCardsDataResponse, transformCrmGuestReturnsEstimateRequest, transformCrmGuestReturnsTypeRequest, transformCrmGuestReturnsTypeResponse, transformSalesReturnsAttributeResponse, transformCrmGuestReturnsRequestRequest, transformSalesPaymentCallbackVerifyResponse, transformSalesPaymentCallbackVerifyRequest, transformSalesPaymentThreedsVerifyResponse, transformSalesPaymentThreedsRequest } from './transformers.js';
import defaultClient from 'axios';

const getCrmGuestOrder = async ({ client , controller , number , email  } = {})=>await client.get(`/V1/crm/guest/order`, {
        signal: controller?.signal,
        params: {
            order_number: number,
            email
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmGuestOrderResponse)
        ]
    });
getCrmGuestOrder.key = 'getCrmGuestOrder';
const getCrmGuestReturns = async ({ client , controller , orderId , protectCode  } = {})=>await client.get(`/V1/crm/guest/returns`, {
        signal: controller?.signal,
        params: {
            order_id: orderId,
            protect_code: protectCode
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmGuestReturnsResponse)
        ]
    });
getCrmGuestReturns.key = 'getCrmGuestReturns';
const getCrmGuestReturn = async ({ client , controller , id , orderId , protectCode  } = {})=>await client.get(`/V1/crm/guest/returns/${id}`, {
        signal: controller?.signal,
        params: {
            order_id: orderId,
            protect_code: protectCode
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmGuestReturnResponse)
        ]
    });
getCrmGuestReturn.key = 'getCrmGuestReturn';
const getSalesCheckoutGiftCardsData = async ({ client , controller , code  } = {})=>await client.get(`/V1/sales/checkout/gift-cards/data`, {
        signal: controller?.signal,
        params: {
            giftCardCode: code
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesCheckoutGiftCardsDataResponse)
        ]
    });
getSalesCheckoutGiftCardsData.key = 'getSalesCheckoutGiftCardsData';
const postCrmGuestReturnsEstimate = async ({ client , controller , city , countryCode , items , postcode , regionId , region  } = {})=>await client.post(`/V1/crm/guest/returns/estimate`, {
        city,
        countryCode,
        items,
        postcode,
        regionId,
        region
    }, {
        signal: controller?.signal,
        transformRequest: [
            transformCrmGuestReturnsEstimateRequest,
            ...(client || defaultClient).defaults.transformRequest
        ]
    });
postCrmGuestReturnsEstimate.key = 'postCrmGuestReturnsEstimate';
const postCrmGuestReturnsType = async ({ client , controller , items  } = {})=>await client.post(`/V1/crm/guest/returns/type`, {
        items
    }, {
        signal: controller?.signal,
        transformRequest: [
            transformCrmGuestReturnsTypeRequest,
            ...(client || defaultClient).defaults.transformRequest
        ],
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmGuestReturnsTypeResponse)
        ]
    });
postCrmGuestReturnsType.key = 'postCrmGuestReturnsType';
const getSalesReturnsAttribute = async ({ client , controller , orderId , itemId , qty , reason  } = {})=>await client.get(`/V1/sales/returns/attributes`, {
        signal: controller?.signal,
        params: {
            order_id: orderId,
            item_id: itemId,
            qty,
            reason_id: reason
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesReturnsAttributeResponse)
        ]
    });
getSalesReturnsAttribute.key = 'getSalesReturnsAttribute';
const postCrmGuestReturnsRequest = async ({ client , controller , orderId , items , easyReturn , easyReturnAddress , protectCode , orderNumber  } = {})=>await client.post(`/V1/crm/guest/returns/request?protect_code=${protectCode}`, {
        orderId,
        items,
        easyReturn,
        easyReturnAddress,
        orderNumber
    }, {
        signal: controller?.signal,
        transformRequest: [
            transformCrmGuestReturnsRequestRequest,
            ...(client || defaultClient).defaults.transformRequest
        ]
    });
postCrmGuestReturnsRequest.key = 'postCrmGuestReturnsRequest';
const postSalesPaymentApplepaySession = async ({ client , controller , validationURL  } = {})=>await client.post(`/V1/sales/payment/applepay/session`, {
        validation_url: validationURL
    }, {
        signal: controller?.signal
    });
postSalesPaymentApplepaySession.key = 'postSalesPaymentApplepaySession';
const postSalesPaymentCallbackVerify = async ({ client , controller , gateway , callbackQueryParams  } = {})=>await client.post(`/V1/sales/payment/callback/verify/${gateway}`, {
        payload: callbackQueryParams
    }, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesPaymentCallbackVerifyResponse)
        ],
        transformRequest: [
            transformSalesPaymentCallbackVerifyRequest,
            ...(client || defaultClient).defaults.transformRequest
        ]
    });
postSalesPaymentCallbackVerify.key = 'postSalesPaymentCallbackVerify';
const postSalesPaymentThreedsVerify = async ({ client , controller , gateway , orderNumber , threedsData  } = {})=>await client.post(`/V1/sales/payment/threeds/verify/${gateway}`, {
        increment_id: orderNumber,
        payload: threedsData
    }, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesPaymentThreedsVerifyResponse)
        ],
        transformRequest: [
            transformSalesPaymentThreedsRequest,
            ...(client || defaultClient).defaults.transformRequest
        ]
    });
postSalesPaymentThreedsVerify.key = 'postSalesPaymentThreedsVerify';

export { getCrmGuestOrder, getCrmGuestReturn, getCrmGuestReturns, getSalesCheckoutGiftCardsData, getSalesReturnsAttribute, postCrmGuestReturnsEstimate, postCrmGuestReturnsRequest, postCrmGuestReturnsType, postSalesPaymentApplepaySession, postSalesPaymentCallbackVerify, postSalesPaymentThreedsVerify };
